import React, { useState } from "react";
import {
  Col,
  Container,
  Form,
  Row,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { Link } from "react-router-dom";
import {
  arbitrum,
  ethereum,
  binance,
  polygon,
  avalanche,
  base,
  berachain,
  neurochain
} from "../../../Components/ConnectMetamaskButton/networks";
import { moedas } from "../../../Components/ConnectMetamaskButton/moedas";
import { ethers } from "ethers";
import { contracts } from "../../../Components/ConnectMetamaskButton/contracts";
import multisendAbi from "../../../Components/ConnectMetamaskButton/multisendAbi";
import erc20Abi from "../../../Components/ConnectMetamaskButton/erc20Abi";
import { toast } from "react-toastify";
import Dropzone from "react-dropzone";

const Contact = ({ networkConfig, setNetworkConfig, isConnected }) => {
  const [networkSelect, setNetworkSelect] = useState("Ethereum");
  const [moedaSelect, setMoedaSelect] = useState(0);
  const [moeda, setMoeda] = useState(moedas[networkSelect][0]);
  const [loading, setLoading] = useState(false);
  const [carteiras, setCarteiras] = useState([[]]);
  const [texto, setTexto] = useState("");
  const [valores, setValores] = useState([[]]);
  const [total, setTotal] = useState(ethers.BigNumber.from(0));
  const [buttonText, setButtonText] = useState("Enviar");
  const [MensagemErro, setMensagemErro] = useState("");
  const [txIds, setTxIds] = useState([]);
  const [quemPaga, setQuemPaga] = useState("sender");
  const [enderecoToken, setEnderecoToken] = useState("");
  const [selectedFiles, setselectedFiles] = useState([]);

  const [modal_center, setmodal_center] = useState(false);
  function tog_center() {
    setmodal_center(!modal_center);
  }

  const cleanTudo = () => {
    setTexto("");
    setCarteiras([[]]);
    setValores([[]]);
    setTotal(ethers.BigNumber.from(0));
    setMensagemErro("");
    setselectedFiles([]);
  };

  const setNetwork = async (network) => {
    setNetworkSelect(network);
    setMoedaSelect(0);
    setMoeda(moedas[network][0]);
    if (network === "Ethereum") {
      setNetworkConfig(ethereum);
    } else if (network === "Arbitrum") {
      setNetworkConfig(arbitrum);
    } else if (network === "Polygon") {
      setNetworkConfig(polygon);
    } else if (network === "Binance") {
      setNetworkConfig(binance);
    } else if (network === "Avalanche") {
      setNetworkConfig(avalanche);
    }else if (network === "Base") {
      setNetworkConfig(base);
    }else if (network === "Berachain") {
      setNetworkConfig(berachain);
    }else if (network === "Neurochain") {
      setNetworkConfig(neurochain);
    }
  };

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  function handleAcceptedFiles(files) {
    const file = files[0];

    setMensagemErro("");

    if (file && file.name.endsWith(".csv")) {
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      });
      setselectedFiles([file]);

      // Ler o conteúdo do arquivo e armazená-lo em 'texto'
      const reader = new FileReader();
      reader.onload = function (e) {
        const content = e.target.result;
        setTexto(content);
      };
      reader.readAsText(file);
    } else {
      setselectedFiles([]);
      cleanTudo();
      toast.error("Por favor, suba um arquivo CSV.");
      setMensagemErro("Por favor, suba um arquivo CSV.");
    }
  }

  const getMoedaDados = async () => {
    setLoading(true);
    setMoedaSelect(-1);
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contractToken = new ethers.Contract(
        enderecoToken,
        erc20Abi,
        signer
      );
      const simbolo = await contractToken.symbol();
      const decimals = await contractToken.decimals();
      setMoeda({
        nome: simbolo,
        contrato: enderecoToken,
        decimals: decimals,
      });
    } catch (error) {
      console.error(error);
      toast.error("Ocorreu um erro ao buscar os dados do token");
    }
    setLoading(false);
  };

  const processarTransacoes = async (texto, decimais) => {
    setTxIds([]);
    try {
      const linhas = texto.trim().split(/\r?\n/);
      const tempCarteiras = [];
      const tempValores = [];
      let totalTemp = ethers.BigNumber.from(0);

      let mensagemErroFinal = "ERROS: \n\n";

      for (const linha of linhas) {
        const linhaTrim = linha.trim(); // Remover espaços em branco

        if (linhaTrim === "") {
          continue; // Ignorar linhas vazias
        }

        // Dividir a linha por vírgula ou ponto-e-vírgula
        const [carteira, valorStr] = linhaTrim.split(/,|;/);

        if (!carteira || !valorStr) {
          continue;
        }

        if (!ethers.utils.isAddress(carteira)) {
          mensagemErroFinal += `Endereço de carteira inválido: ${carteira}\n\n`;
          continue;
        }

        let valor = parseFloat(valorStr.trim());

        if (isNaN(valor)) {
          mensagemErroFinal += `Valor inválido: ${carteira} => ${valorStr}\n\n`;
          continue;
        }

        if (quemPaga === "sender") {
          valor *= 1.005006;
        }

        // Usando BigNumber para adicionar valores
        const valorAsBigNumber = ethers.utils.parseUnits(
          valor.toFixed(decimais),
          decimais
        );

        totalTemp = totalTemp.add(valorAsBigNumber);

        tempCarteiras.push(ethers.utils.getAddress(carteira.trim()));
        tempValores.push(valor);
      }
      if(mensagemErroFinal !== "ERROS: \n\n") setMensagemErro(mensagemErroFinal);

      let valoresTemp = tempValores.map((v) =>
        ethers.utils.parseUnits(v.toFixed(decimais), decimais)
      );

      // Dividindo em grupos de 80
      const gruposCarteiras = [];
      const gruposValores = [];

      for (let i = 0; i < tempCarteiras.length; i += 80) {
        gruposCarteiras.push(tempCarteiras.slice(i, i + 80));
        gruposValores.push(valoresTemp.slice(i, i + 80));
      }

      // Atualize o estado aqui
      setCarteiras(gruposCarteiras);
      setValores(gruposValores);
      setTotal(totalTemp);

      tog_center();
    } catch (error) {
      console.error(error);
      toast.error("Ocorreu um erro ao processar as transações");
      setMensagemErro("Ocorreu um erro ao processar as transações");
    } finally {
      setLoading(false);
    }
  };

  const handleButtonClick = async (e) => {
    setLoading(true);
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      let txs = [];

      const contract = new ethers.Contract(
        contracts[networkConfig.chainName].send_contract,
        multisendAbi,
        signer
      );

      if (!total.isZero()) {
        setMensagemErro("");
        for (let i = 0; i < carteiras.length; i++) {
          setButtonText(`Enviando ${i + 1} de ${carteiras.length} grupos...`);

          if (moeda.contrato === "0x0") {
            const estimate = await contract.estimateGas.multisendEther(
              carteiras[i],
              valores[i],
              { value: total }
            );
            const gasPrice = await provider.getGasPrice();
            const gasLimit = Math.round(estimate.toNumber());
            const tx = await contract.multisendEther(carteiras[i], valores[i], {
              value: total,
              gasPrice,
              gasLimit,
            });
            await tx.wait(1);
            if (tx.hash) txs.push(tx);
            setTxIds(txs);
          } else {
            const contractToken = new ethers.Contract(
              moeda.contrato,
              erc20Abi,
              signer
            );

            if (i === 0) {
              setButtonText("Aprovando...");
              const estimateApprove = await contractToken.estimateGas.approve(
                contracts[networkConfig.chainName].send_contract,
                total
              );
              const gasPrice = await provider.getGasPrice();
              const gasLimit = Math.round(estimateApprove.toNumber());
              const approveTx = await contractToken.approve(
                contracts[networkConfig.chainName].send_contract,
                total,
                {
                  gasPrice,
                  gasLimit,
                }
              );
              await approveTx.wait(1);
            }

            const estimate = await contract.estimateGas.multisendToken(
              moeda.contrato,
              carteiras[i],
              valores[i]
            );
            const gasLimit = Math.round(estimate.toNumber());
            const tx = await contract.multisendToken(
              moeda.contrato,
              carteiras[i],
              valores[i],
              {
                gasLimit,
              }
            );
            await tx.wait(1);
            if (tx.hash) txs.push(tx);
            setTxIds(txs);
          }
        }
        toast.success("Transação enviada com sucesso!");
        setMensagemErro("");
        cleanTudo();
      } else if (carteiras[0].length > 0) {
        toast.error("O valor total deve ser maior que 0.");
        setMensagemErro("O valor total deve ser maior que 0.");
        cleanTudo();
      }
    } catch (error) {
      toast.error("Erro ao enviar transação!");
      setMensagemErro("Erro ao enviar transação!");
      cleanTudo();
      console.error(error);
    } finally {
      setButtonText("Enviar");
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <section className="section" id="contact">
        <Modal
          isOpen={modal_center}
          toggle={() => {
            tog_center();
          }}
          centered
        >
          <ModalHeader>Atenção! Risco de perda de ativos!</ModalHeader>
          <ModalBody className="text-center p-5">
            <img
              src="https://api.fort.exchange/image/danger.png"
              alt="danger"
              className="avatar-md"
              style={{ height: "200px", width: "200px" }}
            />
            <div className="mt-4">
              <p className="text-warning-light mb-4">
                {" "}
                Ao usar contratos de Multisend,{" "}
                <b className="text-warning">
                  não utilize carteiras de exchange
                </b>{" "}
                para receber os valores.
              </p>
              <p className="text-danger mb-4">
                <b>
                  UMA EXCHANGE PODE NEGAR A ENTRADA DE TOKENS SE A CARTEIRA NÃO
                  FOR ESPECÍFICA PARA ELE!
                </b>
              </p>
              <div className="hstack gap-2 justify-content-center">
                <Button color="danger" onClick={() => setmodal_center(false)}>
                  Clique aqui se entendeu
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center mb-5">
                <h3 className="mb-3 fw-semibold">Prepare a sua transação</h3>
                <p style={{ color: "lightyellow" }}>
                  {
                    "Você deve preparar o arquivo CSV conforme o vídeo acima orienta. Cada linha deve conter um endereço e um valor sem separador de milhares (usando o ponto < . > para as casas decimais ), separados por uma vírgula."
                  }
                </p>
              </div>
            </Col>
          </Row>

          <Row className="gy-4">
            <Col lg={4}>
              <div>
                <div className="mt-4">
                  <h4 className="fs-13 text-warning text-uppercase">
                    Baixe aqui o CSV de exemplo:
                  </h4>
                  <div className="ff-secondary fw-semibold">
                    <Link to="/multisend.csv" target="_blank">
                      CSV
                    </Link>
                  </div>
                </div>
                <div className="mt-4">
                  <h5 className="fs-13 text-muted text-uppercase">
                    Redes Aceitas:
                  </h5>
                </div>
                <div className="mt-4">
                  <div className="ff-secondary fw-semibold">
                    <Link
                      to="https://etherscan.io/address/0xf7f0cc5a1afd686e891d5c5b033f621b2131b241"
                      target="_blank"
                      title="Ver o Contrato"
                    >
                      Ethereum
                    </Link>
                  </div>
                  <div className="ff-secondary fw-semibold">
                    <Link
                      to="https://bscscan.com/address/0xF87eFCBB77f93D32201d472A1EdE7dAe8b765Ba3"
                      target="_blank"
                      title="Ver o Contrato"
                    >
                      Binance Smart Chain
                    </Link>
                  </div>
                  <div className="ff-secondary fw-semibold">
                    <Link
                      to="https://polygonscan.com/address/0x897C7d214fEF07e02Ab997B443c846BBfde1b9DA"
                      target="_blank"
                      title="Ver o Contrato"
                    >
                      Polygon
                    </Link>
                  </div>
                  <div className="ff-secondary fw-semibold">
                    <Link
                      to="https://arbiscan.io/address/0x2F92A44C7d0ef5609E7113671982Cf2abC956d60"
                      target="_blank"
                      title="Ver o Contrato"
                    >
                      Arbitrum
                    </Link>
                  </div>
                  <div className="ff-secondary fw-semibold">
                    <Link
                      to="https://snowtrace.io/address/0x9f78f4A2c5327896079E9Abb4DE978d8966f8E3B"
                      target="_blank"
                      title="Ver o Contrato"
                    >
                      Avalanche
                    </Link>
                  </div>
                  <div className="ff-secondary fw-semibold">
                    <Link
                      to="https://berascan.com/address/0x9f78f4A2c5327896079E9Abb4DE978d8966f8E3B"
                      target="_blank"
                      title="Ver o Contrato"
                    >
                      Berachain
                    </Link>
                  </div>
                  <div className="ff-secondary fw-semibold">
                    <Link
                      to="https://basescan.org/address/0x32DD07D68D746864d755Deb9AdAf1a757787F852"
                      target="_blank"
                      title="Ver o Contrato"
                    >
                      Base
                    </Link>
                  </div>
                  <div className="ff-secondary fw-semibold">
                    <Link
                      to="https://ncnscan.com/address/0xaF9e4166F3757eB049c55B1dc5Bb08EF3df6Be58"
                      target="_blank"
                      title="Ver o Contrato"
                    >
                      Neurochain
                    </Link>
                  </div>
                </div>
                <div className="mt-4">
                  <h5 className="fs-13 text-muted text-uppercase">
                    Limite por transação:
                  </h5>
                </div>
                <div className="mt-4">
                  <div className="ff-secondary fw-semibold">80 envios</div>
                </div>
              </div>
            </Col>

            <Col lg={8}>
              <div>
                <Form>
                  <Row>
                    <Col lg={6}>
                      <div className="mb-4">
                        <label htmlFor="subject" className="form-label fs-13">
                          Rede
                        </label>
                        <select
                          className="form-control bg-light border-light"
                          onChange={(e) => setNetwork(e.target.value)}
                          value={networkSelect}
                        >
                          <option value="Ethereum">Ethereum</option>
                          <option value="Arbitrum">Arbitrum</option>
                          <option value="Polygon">Polygon</option>
                          <option value="Binance">BSC</option>
                          <option value="Avalanche">Avalanche</option>
                          <option value="Berachain">Berachain</option>
                          <option value="Base">Base</option>
                          <option value="Neurochain">Neurochain</option>
                        </select>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-4">
                        <label htmlFor="subject" className="form-label fs-13">
                          Token
                        </label>
                        <select
                          className="form-control bg-light border-light"
                          onChange={(e) => {
                            setMoedaSelect(e.target.value);
                            if (e.target.value !== -1) {
                              setMoeda(moedas[networkSelect][e.target.value]);
                            } else {
                              setMoeda(null);
                            }
                            setEnderecoToken("");
                            setTotal(ethers.BigNumber.from(0));
                            setCarteiras([[]]);
                            setValores([[]]);
                            setTxIds([]);
                            setMensagemErro("");
                          }}
                          value={moedaSelect}
                        >
                          {moedas[networkSelect].map((moeda, index) => (
                            <option key={index} value={index}>
                              {moeda.nome}
                            </option>
                          ))}
                          <option value={-1}>Outros</option>
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={9}>
                      <div className="mb-3">
                        <label htmlFor="subject" className="form-label fs-13">
                          Token Personalizado
                        </label>
                        <input
                          type="text"
                          className="form-control bg-light border-light"
                          placeholder="Endereço do Token"
                          maxLength={42}
                          value={enderecoToken}
                          onChange={(e) => setEnderecoToken(e.target.value)}
                        />
                      </div>
                      {enderecoToken !== "" &&
                        moeda &&
                        moedaSelect === -1 &&
                        !loading && (
                          <div className="mb-3">
                            <p className="text-muted mb-2 ff-secondary">
                              <b>Token: </b>
                              {moeda.nome}
                            </p>
                          </div>
                        )}
                    </Col>
                    <Col lg={3}>
                      <div className="mb-3" style={{ paddingTop: "28px" }}>
                        <Button
                          className="btn"
                          color="primary"
                          onClick={(e) => {
                            getMoedaDados();
                          }}
                          disabled={!isConnected || loading}
                        >
                          Buscar Dados
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    {texto === "" && (
                      <Col lg={12}>
                        <div className="mb-3">
                          <Dropzone
                            onDrop={(acceptedFiles) => {
                              handleAcceptedFiles(acceptedFiles);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <div className="dropzone dz-clickable">
                                <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  <div className="mb-3">
                                    <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                  </div>
                                  <h4>
                                    Suba aqui o CSV com as carteiras e valores
                                  </h4>
                                </div>
                              </div>
                            )}
                          </Dropzone>
                        </div>
                      </Col>
                    )}

                    {texto !== "" && (
                      <>
                        <Col lg={12}>
                          <div className="mb-3">
                            <textarea
                              className="form-control bg-light border-light"
                              rows="5"
                              placeholder="Endereços e valores"
                              value={texto}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={8}></Col>
                        <Col lg={4} className="text-end">
                          <Button
                            className="btn"
                            color="danger"
                            onClick={() => {
                              cleanTudo();
                            }}
                          >
                            Refazer
                          </Button>
                        </Col>
                      </>
                    )}
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <p className="text-muted mb-4 ff-secondary">
                        <b className="text-danger">*</b> Uma taxa de 0.5% será
                        aplicada ao envio.
                      </p>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-4">
                        <input
                          type="radio"
                          name="radio"
                          value={quemPaga}
                          onChange={(e) => {
                            setQuemPaga("sender");
                            setTotal(ethers.BigNumber.from(0));
                            setCarteiras([[]]);
                            setValores([[]]);
                            setTxIds([]);
                            setMensagemErro("");
                          }}
                          checked={quemPaga === "sender"}
                        />

                        <label
                          htmlFor="subject"
                          className="form-label fs-13  p-1"
                        >
                          Você paga a taxa
                        </label>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-4">
                        <input
                          type="radio"
                          name="radio"
                          value={quemPaga}
                          onChange={(e) => {
                            setQuemPaga("receiver");
                            setTotal(ethers.BigNumber.from(0));
                            setCarteiras([[]]);
                            setValores([[]]);
                            setTxIds([]);
                            setMensagemErro("");
                          }}
                          checked={quemPaga === "receiver"}
                        />

                        <label
                          htmlFor="subject"
                          className="form-label fs-13 p-1"
                        >
                          Quem recebe paga a taxa
                        </label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      Rede: <b>{networkSelect}</b>
                      {carteiras.map((grupo, i) => (
                        <p key={i} className="text-muted mb-4 ff-secondary">
                          {!total.isZero() && (
                            <b>
                              {`Grupo ${i + 1}: ${ethers.utils.formatUnits(
                                total,
                                moeda?.decimals
                              )} ${moeda?.nome} para ${
                                grupo.length
                              } carteira(s)`}
                            </b>
                          )}
                        </p>
                      ))}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={8}>
                      <b className="text-danger">{MensagemErro}</b>

                      {txIds.length > 0 &&
                        txIds.map((tx, i) => (
                          <Link
                            key={i}
                            to={`${networkConfig.blockExplorerUrls}tx/${tx.hash}`}
                            target="_blank"
                            className="btn btn-sm btn-info m-2"
                          >
                            Ver Transação Grupo {i + 1}
                          </Link>
                        ))}
                    </Col>
                    <Col lg={4} className="text-end">
                      {!total.isZero() ? (
                        <Button
                          className="btn"
                          color="primary"
                          onClick={(e) => handleButtonClick(e)}
                          disabled={!isConnected || loading || !moeda}
                        >
                          {buttonText}
                        </Button>
                      ) : (
                        <Button
                          className="btn"
                          color="primary"
                          onClick={(e) =>
                            processarTransacoes(texto, moeda?.decimals)
                          }
                          disabled={
                            (enderecoToken !== "" && moedaSelect !== -1) ||
                            !isConnected ||
                            loading ||
                            !moeda
                          }
                        >
                          Preparar Envio
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Contact;
